<template>
    <div>
        <h1>Data og personvern</h1>
        <p>
            Vi innhenter besøksstatistikk for tjenesten ved bruk av Google Analytics. Formålet med dette er å lage statistikk som vi bruker til å forbedre og
            videreutvikle tjenesten. Eksempler på hva statistikken gir svar på, er hvor mange som er abonnert på varsel om flomfare og hvor mange som klikker på
            linkene i mottatte varsel. Besøksstatistikken i varsom.no inkluderer oversikt over besøkendes IP-adresse, hvilke sider som er lest, tidspunkt, hvilken
            side vedkommende kom fra, samt type nettleser og operativsystem som benyttes. IP-adresser anonymiseres så snart dette er teknisk mulig, og før de
            lagres som besøksdata. Besøksdata behandles kun på aggregert nivå.
        </p>
        <p>
            <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage" target="new"
                >Les mer om Google Analytics bruk av "cookies" til måling av webstatistikk.</a
            >
            <br />
            <a href="https://www.nve.no/nves-personvernerklaering" target="new">Les mer om NVEs personvernerklæring.</a>
        </p>
        <p>Du legger igjen litt informasjon om deg selv når du oppretter bruker. Det er greit å vite litt hva vi gjør med den:</p>
        <p>
            <strong>E-post:</strong> E-postadressen din benyttes som bruker. Den logger du inn med. Hvis du har glemt passord sender vi deg nytt passord til den
            adressen. Varsel du har abonnert på sendes til den e-postadressen hvis du har valgt å få varsel på e-post
        </p>
        <p>
            <strong>Mobilnummer:</strong> Dette er valgfritt å legge inn. Mobilnummer brukes kun for å sende deg varsel på SMS hvis du har valgt å få varsel på
            SMS. Når du oppgir et mobilnummer får du en SMS for å validere abonnementet og kontrollere at du er riktig person.
        </p>
        <p>
            Hvis du har abonnert før sommeren 2019, har du muligens også registrert navnet ditt, postnummer og brukerkategorier. Denne informasjonen vil bli
            slettet for å tilfredsstille personvern og GDPRs-direktivet. Den nye abonnementsløsningen som ble lansert sommeren 2019 støtter ikke lenger pålogging
            med Google eller Facebook. Har du en slik pålogging må du opprette et nytt abonnement. Din gamle bruker med tilhørende informasjon blir slettet.
        </p>
        <p>Du kan når som helst stoppe abonnementene dine. Du kan også slette brukeren din (velg fanen NVE konto, brukerdata og sletting)</p>
    </div>
</template>

<script>
    export default {
        name: "Personvern"
    };
</script>